import type { PropertiesType } from './properties.types'
import type { ReporterType } from './reporter.types'
import type { WatcherType } from './watcher.types'

export type TicketType = {
  access_level: string
  title: string
  id: string
  state: TicketStateType
  created_at: string
  updated_at: string
  watchers: WatcherType[]
  reporter?: ReporterType
  properties: TicketPropertiesType[]
}

export type TicketPropertiesType = {
  id: string
  ticket_id: string
  property: PropertiesType
  value: string
  created_at: string
  updated_at: string
}

export enum TicketStateEnum {
  NEW = 'NEW',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  SOLVED = 'SOLVED',
  PENDING = 'PENDING',
  'ON HOLD' = 'ON HOLD',
  HIDDEN = 'HIDDEN',
}

export type TicketStateType = keyof typeof TicketStateEnum
